module.exports = __webpack_public_path__ + "img/ico_youtube_new_line.e6f35ffb.svg";